
export const SEARCH = 'Search'
export const CATEGORY = 'category'
export const HOT_DEALS = 'Hot Deals'
export const HOME_MESSAGE = 'Lets Shop!'
export const BEST_SELLERS = 'Best Sellers'
export const USED_PRODUCTS = 'Used Products'
export const SEARCH_EXAMPLE = 'ej. bookshelves'
